import OrgChartContainer from "./evaluationOrgChart.container";

export default OrgChartContainer;
